var _path, _circle, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _circle4, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 185,
    viewBox: "0 0 423 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.938 96.9866L317.404 96.2618C317.404 96.2618 303.559 101.427 289.689 111.64C275.819 121.854 264.004 135.585 264.004 135.585L264.538 136.31C264.538 136.31 277.393 121.813 290.223 112.365C303.053 102.917 317.938 96.9866 317.938 96.9866Z",
    fill: "#22252A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 9,
    fill: "#E10512"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.722 80.4068C175.498 78.8122 176.568 76.5774 176.696 74.1939C176.825 71.8104 176.001 69.4735 174.407 67.6973C172.812 65.9211 170.577 64.851 168.194 64.7225C165.81 64.594 163.473 65.4176 161.697 67.0122L167.709 73.7095L173.722 80.4068Z",
    fill: "#0062CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.092 58.3639C360.404 56.6761 358.115 55.7279 355.728 55.7279C353.341 55.7279 351.052 56.6761 349.364 58.3639C347.676 60.0518 346.728 62.341 346.728 64.7279C346.728 67.1149 347.676 69.404 349.364 71.0919L355.728 64.7279L362.092 58.3639Z",
    fill: "#E10512"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.345 141.864C102.248 140.711 100.739 140.041 99.1478 140.002C97.5569 139.962 96.0155 140.556 94.8626 141.653C93.7097 142.75 93.0398 144.26 93.0001 145.85C92.9605 147.441 93.5544 148.983 94.6513 150.136L98.9983 146L103.345 141.864Z",
    fill: "#E10512"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5078 116.349L88.0514 115.611C88.0514 115.611 78.3266 103.324 63.5742 92.4559C48.8217 81.5875 31.2545 73.7675 31.2545 73.7675L30.7109 74.5053C30.7109 74.5053 49.3846 83.1404 63.0306 93.1937C76.6766 103.247 87.5078 116.349 87.5078 116.349Z",
    fill: "#22252A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212 1L211.102 0.990007C211.102 0.990007 206.895 15.8605 206.694 33.9399C206.493 52.0193 210.327 70.5957 210.327 70.5957L211.225 70.6057C211.225 70.6057 207.406 50.6734 207.592 33.9499C207.778 17.2265 212 1 212 1Z",
    fill: "#22252A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 38,
    r: 5,
    fill: "#00BB86"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 319,
    cy: 176,
    r: 9,
    fill: "#00BB86"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 165,
    r: 9,
    fill: "#0062CE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150.758,
    y: 9.08435,
    width: 6,
    height: 6,
    transform: "rotate(-46.1388 150.758 9.08435)",
    fill: "#00BB86"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 316.66,
    y: 111.876,
    width: 6,
    height: 6,
    transform: "rotate(7.50624 316.66 111.876)",
    fill: "#0062CE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.76953,
    y: 91.7097,
    width: 10,
    height: 10,
    transform: "rotate(17.8199 3.76953 91.7097)",
    fill: "#00BB86"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 412.57,
    y: 124.815,
    width: 10,
    height: 10,
    transform: "rotate(16 412.57 124.815)",
    fill: "#0062CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.8c837a6c89654b48976b0cfecc59fb23.svg";
export { ForwardRef as ReactComponent };